class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    // Call the function on page load
    
    // Listen for selling plan changes
    this.addEventListener('change', (event) => {
      if (event.target.matches('.cart-drawer-b-version__subscription-details-select')) {
        this.handleSellingPlanChange(event);
      }
    }); 

    // Listen for selling plan changes
    this.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"][name^="selling_plan_"]')) {
        this.handleSellingPlanChange(event);
      }
    });

    // Listen for selling plan changes
    this.addEventListener('change', (event) => {
      if (event.target.matches('.switch input[type="checkbox"]')) {
        this.handleCheckboxChange(event);
      }
    }); 
 
  }


 handleCheckboxChange(event) {
    const cartItemIndex = event.target.getAttribute('cart-item-index');
    const isChecked = event.target.checked;

    const subscriptionDetails = document.querySelector(
      `.cart-drawer-b-version__subscription-details select[data-index="${cartItemIndex}"]`
    )?.closest('.cart-drawer-b-version__subscription-details');

    if (!subscriptionDetails) return;

    const lineItem = document.querySelector(`#CartDrawer-Item-${cartItemIndex}, #CartItem-${cartItemIndex}`);
    const quantityInput = lineItem.querySelector('input[data-quantity-variant-id]');
   const quantityValue = quantityInput.value; 
    const variantId = quantityInput.getAttribute('data-quantity-variant-id');
    const subscriptionSelect = document.querySelector(`.cart-drawer-selector-${cartItemIndex}`);

    const sellingPlan = isChecked
      ? { sellingPlanId: subscriptionSelect.options[1]?.value || '' }
      : { sellingPlanId: '' };

    subscriptionDetails.style.display = isChecked && sellingPlan.sellingPlanId ? 'block' : 'none';
   
    this.updateSellingPlan(
      cartItemIndex,
      quantityValue,
      lineItem.querySelector('input[name="updates[]"]').name,
      variantId,
      sellingPlan
    );
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

    // Fetch and update free shipping progress when the component is connected
    // this.fetchCartTotalAndUpdateProgress();
    this.attachEventListeners();
    this.initFreeProductSelector(); // Initialize free product selector
    
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }



// =============================================
// FREE PRODUCT SELECTOR FUNCTIONALITY - DROPDOWN
// =============================================

initFreeProductSelector() {
  const dropdownToggle = document.getElementById('productDropdown');
  const dropdownMenu = document.getElementById('dropdownMenu');
  const successMessage = document.getElementById('successMessage');
  
  if (!dropdownToggle || !dropdownMenu) return; // Exit if free product selector doesn't exist

  // Get threshold from hidden input (value should be in cents, e.g., 5000 for $50)
  const thresholdInput = document.getElementById('free_gift_threshold_dropdown');
  this.FREE_GIFT_THRESHOLD = thresholdInput ? parseInt(thresholdInput.value, 10) : 0;
  
  // Initialize flag to prevent multiple submissions
  this.isAddingFreeProduct = false;
  
  // If no valid threshold is set, don't show the free gift selector
  if (!this.FREE_GIFT_THRESHOLD || isNaN(this.FREE_GIFT_THRESHOLD)) {
    console.warn('Free gift threshold not set or invalid');
    return;
  }

  // Check cart threshold and free product status
  this.checkCartThresholdAndFreeProduct();

  // Remove existing event listeners by cloning and replacing elements
  const newDropdownToggle = dropdownToggle.cloneNode(true);
  dropdownToggle.parentNode.replaceChild(newDropdownToggle, dropdownToggle);
  
  // Toggle dropdown
  newDropdownToggle.addEventListener('click', (e) => {
    e.stopPropagation();
    newDropdownToggle.classList.toggle('active');
    dropdownMenu.classList.toggle('active');
  });
  
  // Remove old document click listener and add new one
  if (this.outsideClickHandler) {
    document.removeEventListener('click', this.outsideClickHandler);
  }
  
  this.outsideClickHandler = (event) => {
    if (!event.target.closest('.product-dropdown')) {
      const currentDropdownToggle = document.getElementById('productDropdown');
      const currentDropdownMenu = document.getElementById('dropdownMenu');
      if (currentDropdownToggle && currentDropdownMenu) {
        currentDropdownToggle.classList.remove('active');
        currentDropdownMenu.classList.remove('active');
      }
    }
  };
  
  document.addEventListener('click', this.outsideClickHandler);
  
  // Update button variant ID when variant changes
  const variantSelects = dropdownMenu.querySelectorAll('.variant-select');
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const productItem = this.closest('.product-item');
      const addButton = productItem.querySelector('.add-to-cart-btn');
      addButton.setAttribute('data-variant-id', this.value);
    });
  });
  
  // Add to cart functionality for free products
  const addToCartButtons = dropdownMenu.querySelectorAll('.add-to-cart-btn');
  addToCartButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      this.addFreeProductToCart(button);
    });
  });
}

checkCartThresholdAndFreeProduct() {
  // Fetch current cart state
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Find the free gift item if it exists
      const freeGiftItem = cart.items.find(item => 
        item.properties && item.properties._free_gift_product === 'true'
      );
      
      // Calculate cart total excluding free gift items
      const cartTotalWithoutFreeGift = cart.items.reduce((total, item) => {
        if (item.properties && item.properties._free_gift_product === 'true') {
          return total;
        }
        return total + (item.final_line_price || item.line_price);
      }, 0);
      
      const meetsThreshold = cartTotalWithoutFreeGift >= this.FREE_GIFT_THRESHOLD;
      const productDropdownContainer = document.querySelector('.free-product-selector');
      
      if (freeGiftItem && !meetsThreshold) {
        // Cart dropped below threshold - remove the free gift
        this.removeFreeGiftFromCart(freeGiftItem.key);
      } else if (productDropdownContainer) {
        if (freeGiftItem) {
          // Free gift already in cart - hide selector
          productDropdownContainer.style.display = 'none';
        } else if (meetsThreshold) {
          // Threshold met and no free gift - show selector
          productDropdownContainer.style.display = 'block';
        } else {
          // Threshold not met - hide selector
          productDropdownContainer.style.display = 'none';
        }
      }
      
      // Update threshold progress message if element exists
      this.updateThresholdMessage(cartTotalWithoutFreeGift);
    })
    .catch(error => {
      console.error('Error checking cart for free products:', error);
    });
}

updateThresholdMessage(currentTotal) {
  const thresholdMessage = document.getElementById('thresholdMessage');
  if (!thresholdMessage) return;
  
  const remaining = this.FREE_GIFT_THRESHOLD - currentTotal;
  
  if (remaining > 0) {
    const remainingFormatted = (remaining / 100).toFixed(2);
    thresholdMessage.innerHTML = `Add <strong>$${remainingFormatted}</strong> more to unlock your free gift!`;
    thresholdMessage.style.display = 'block';
  } else {
    thresholdMessage.style.display = 'none';
  }
}

removeFreeGiftFromCart(lineItemKey) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: lineItemKey,
      quantity: 0
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Free gift removed - cart below threshold');
    // Refresh cart display
    this.refreshCartAfterFreeProduct();
  })
  .catch(error => {
    console.error('Error removing free gift:', error);
  });
}

addFreeProductToCart(button) {
  // Prevent multiple clicks
  if (this.isAddingFreeProduct) {
    console.log('Already adding free product, please wait...');
    return;
  }
  
  const variantId = button.getAttribute('data-variant-id');
  const productTitle = button.getAttribute('data-product-title');
  const successMessage = document.getElementById('successMessage');
  const dropdownToggle = document.getElementById('productDropdown');
  const dropdownMenu = document.getElementById('dropdownMenu');
  
  // Set flag and disable ALL add-to-cart buttons
  this.isAddingFreeProduct = true;
  const allAddButtons = document.querySelectorAll('.add-to-cart-btn');
  allAddButtons.forEach(btn => {
    btn.disabled = true;
  });
  button.textContent = 'Adding...';
  
  // First, verify cart still meets threshold
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Check if free gift already exists
      const hasFreeProduct = cart.items.some(item => 
        item.properties && item.properties._free_gift_product === 'true'
      );
      
      if (hasFreeProduct) {
        alert('You already have a free gift in your cart.');
        this.resetAddButtonState(allAddButtons, button);
        this.checkCartThresholdAndFreeProduct();
        return;
      }
      
      // Calculate cart total excluding any existing free gifts
      const cartTotalWithoutFreeGift = cart.items.reduce((total, item) => {
        if (item.properties && item.properties._free_gift_product === 'true') {
          return total;
        }
        return total + (item.final_line_price || item.line_price);
      }, 0);
      
      if (cartTotalWithoutFreeGift < this.FREE_GIFT_THRESHOLD) {
        alert('Your cart no longer meets the minimum threshold for a free gift.');
        this.resetAddButtonState(allAddButtons, button);
        this.checkCartThresholdAndFreeProduct();
        return;
      }
      
      // Proceed with adding free product
      this.proceedWithAddingFreeProduct(button, variantId, productTitle, successMessage, dropdownToggle, dropdownMenu, allAddButtons);
    })
    .catch(error => {
      console.error('Error verifying cart threshold:', error);
      alert('There was an error. Please try again.');
      this.resetAddButtonState(allAddButtons, button);
    });
}

resetAddButtonState(allAddButtons, clickedButton) {
  this.isAddingFreeProduct = false;
  allAddButtons.forEach(btn => {
    btn.disabled = false;
  });
  clickedButton.textContent = 'Add to Cart';
}

proceedWithAddingFreeProduct(button, variantId, productTitle, successMessage, dropdownToggle, dropdownMenu, allAddButtons) {
  // Prepare form data with line item properties
  const formData = {
    items: [{
      id: variantId,
      quantity: 1,
      properties: {
        '_free_gift_product': 'true',
      }
    }]
  };
  
  // Add to cart via AJAX
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    // Show success message
    if (successMessage) {
      successMessage.classList.add('show');
      setTimeout(() => {
        successMessage.classList.remove('show');
      }, 3000);
    }
    
    // Close dropdown
    if (dropdownToggle && dropdownMenu) {
      dropdownToggle.classList.remove('active');
      dropdownMenu.classList.remove('active');
      
      // Update dropdown text
      const dropdownText = dropdownToggle.querySelector('.dropdown-text');
      if (dropdownText) {
        dropdownText.textContent = productTitle + ' added!';
      }
    }
    
    // Reset button states
    this.resetAddButtonState(allAddButtons, button);
    
    // Refresh cart
    this.refreshCartAfterFreeProduct();
  })
  .catch(error => {
    console.error('Error:', error);
    alert('There was an error adding the item to cart. Please try again.');
    this.resetAddButtonState(allAddButtons, button);
  });
}

refreshCartAfterFreeProduct() {
  const isCartDrawer = document.querySelector('cart-drawer-items') !== null;
  const sectionId = isCartDrawer ? 'cart-drawer' : 'main-cart-items';
  const fetchUrl = `${window.Shopify.routes.root}cart?section_id=${sectionId}`;

  fetch(fetchUrl)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const selectors = isCartDrawer
        ? ['cart-drawer-items', '.cart-drawer__footer']
        : ['cart-items', '.js-contents'];

      selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      });

      // Reinitialize free product selector after refresh
      setTimeout(() => {
        this.initFreeProductSelector();
      }, 100);
    })
    .catch((e) => {
      console.error('Error refreshing cart:', e);
    });
}
// ==========================================
// END FREE PRODUCT SELECTOR FUNCTIONALITY
// ==========================================




  // Your existing code (inside attachEventListeners)
  attachEventListeners() 
  {
    
    let timerInput = document.querySelector('#timer_count');
    if(timerInput)
    {
      let timeLeft = timerInput ? parseFloat(timerInput.value) * 60 : 0; // Default to 0 if the element is not found
      let timerElement = document.querySelector('.timetext');
      timerElement = timerInput? document.querySelector('.timetext') : '';
  
      if (timerElement) {
        const countdown = setInterval(() => {
          let minutes = Math.floor(timeLeft / 60);
          let seconds = timeLeft % 60;
          timerElement.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
          timeLeft--;
          if (timeLeft < 0) {
            clearInterval(countdown);
            timerElement.textContent = "Time's up!";
          }
        }, 1000);
      } 
      else {
        console.error("Element with class timetext not found.");
      }
  
      // Function to update the width of the progress bar
      function updateProgressBar(percentage) {
        const progressBars = document.querySelectorAll('.xbar');
        let percentagetext = '';
        progressBars.forEach(progressBar => {
          progressBar.style.width = percentage + '%';
          if (percentage == 66.66) {
            percentagetext = 20;
          } else if (percentage == 99.99) {
            percentagetext = 30;
          } else {
            percentagetext = 10;
          }
          progressBar.textContent = percentagetext + '%';
        });
      }
  
      let xcart_item_count = document.querySelector('.xcart_item_count').value;
      let xcart_item_count_progress = xcart_item_count;
      if (xcart_item_count == 2) {
        xcart_item_count = 1;
      } else {
        xcart_item_count = 2;
      }
      let selectedCount = 0;
      const selectedItems = [];
  
      document.querySelectorAll('.additem').forEach(button => {
        button.addEventListener('click', function() {
          if (selectedCount < xcart_item_count) {
            const item = this.closest('.xitems');
            const productName = item.querySelector('.pname').innerText;
            const variant = item.querySelector('.xvariant').value;
            const price = item.querySelector('.xprice').innerText;
            const imageSrc = item.querySelector('img').src;
            const subscribeDiscountPct = item.querySelector('.js-subscribe-discount-pct')?.value || null;
            const applyDiscount = item.querySelector('.apply_discount')?.value || null;
    
            selectedItems.push({
              productName: productName,
              variant: variant,
              price: price,
              imageSrc: imageSrc,
              quantity: 1,
              subscribeDiscountPct:subscribeDiscountPct,
              applyDiscount:applyDiscount,
            });
    
            if (selectedCount == 0 && xcart_item_count_progress == 1) {
              updateProgressBar(66.66);
            } else if (selectedCount == 0 && xcart_item_count_progress == 2) {
              updateProgressBar(99.99);
            } else if (selectedCount == 1 && xcart_item_count_progress == 1) {
              updateProgressBar(99.99);
            }
    
            const productElementOffer = document.createElement('div');
            productElementOffer.classList.add('xproduct');
            productElementOffer.innerHTML = `
              <img src="${imageSrc}" width="50" alt="${productName}">
              <div class="xremove" role="button" aria-label="Remove item">
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="removeItemTitle">
    <title id="removeItemTitle">Remove item</title>
    <path d="M6.39317 0.666748L3.99984 3.06008L1.6065 0.666748L0.666504 1.60675L3.05984 4.00008L0.666504 6.39341L1.6065 7.33341L3.99984 4.94008L6.39317 7.33341L7.33317 6.39341L4.93984 4.00008L7.33317 1.60675L6.39317 0.666748Z" fill="white"></path>
  </svg>
</div>`;
    
            document.querySelector('.selected-product').appendChild(productElementOffer);
            document.querySelector('.selected-product').classList.add('selected-product' + selectedCount);
    
            item.style.display = 'none';
            selectedCount++;
    
            if (selectedCount === xcart_item_count) {
              document.querySelectorAll('.additem').forEach(btn => {
                if (btn.closest('.xitems').style.display !== 'none') {
                  btn.classList.add('disabled');
                  btn.closest('.xitems').style.display = 'none';
                  document.querySelector('.xbtn.more').style.display = 'none';
                }
              });
            }
    
            productElementOffer.querySelector('.xremove').addEventListener('click', function() {
              const productElement = this.closest('.xproduct');
              productElement.remove();
              selectedCount--;
              if (selectedCount == 0 && xcart_item_count_progress == 1) {
                updateProgressBar(33.33);
              } else if (selectedCount == 1 && xcart_item_count_progress == 1) {
                updateProgressBar(66.66);
              } else if (selectedCount == 1 && xcart_item_count_progress == 2) {
                updateProgressBar(66.66);
              } else if (selectedCount == 0 && xcart_item_count_progress == 2) {
                updateProgressBar(66.66);
              }
    
              document.querySelector('.selected-product').classList.remove('selected-product' + selectedCount);
              if (productElement) {
                selectedItems.splice(selectedItems.findIndex(item => item.productName === productName && item.variant === variant), 1);
                item.style.display = 'flex';
                if (selectedCount < xcart_item_count) {
                  document.querySelectorAll('.additem.disabled').forEach(btn => {
                    btn.classList.remove('disabled');
                    btn.closest('.xitems').style.display = 'flex';
                    document.querySelector('.xbtn.more').style.display = 'block';
                  });
                }
              }
            });
          }
        });
      });
  
      document.querySelector('.additemtocart').addEventListener('click', function() {
        addToCart(selectedItems);
        const addToCartButton = this;
        addToCartButton.textContent = 'Adding...';
        addToCartButton.disabled = true;
      });
  
      
  
      function addToCart(items) {
        if (items.length === 0) {
          console.log('No items selected.');
          return;
        }
    
        let formData = new FormData();
        formData = {
          items: items.map(item => ({
            id: item.variant,
            quantity: item.quantity,
            properties: {
              "_apply_discount": item.applyDiscount,
              _cart_calculation: item.subscribeDiscountPct
              
            }
          }))
        };
    
        let addToCartButton = document.querySelector('.additemtocart');
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(formData)
        })
          .then(response => response.json())
          .then(data => {
            addToCartButton.textContent = 'Added to Cart';
            selectedItems.length = 0;
            selectedCount = 0;
            document.querySelector('.selected-product').innerHTML = '';
            document.body.classList.remove('xt-cart-recommended-active');
  
  
          })
          .catch((error) => {
            console.error('Error:', error);
            addToCartButton.textContent = 'Parameter missing';
          })
          .finally(() => {
              
                const isCartDrawer = document.querySelector('cart-drawer-items') !== null; // Check if in cart drawer
              const sectionId = isCartDrawer ? 'cart-drawer' : 'main-cart-items';
              const fetchUrl = `${window.Shopify.routes.root}cart?section_id=${sectionId}`;
            
              fetch(fetchUrl)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const selectors = isCartDrawer
                    ? ['cart-drawer-items', '.cart-drawer__footer']
                    : ['cart-items', '.js-contents'];
            
                  selectors.forEach((selector) => {
                    const targetElement = document.querySelector(selector);
                    const sourceElement = html.querySelector(selector);
                    if (targetElement && sourceElement) {
                      targetElement.replaceWith(sourceElement);
                    }
                  });
                })
                .catch((e) => {
                  console.error('Error refreshing cart:', e);
                });
             
          });
      }
    
      document.querySelector('.xt-another-box').addEventListener('click', function() {
        document.querySelector('.xt-cart-recommended').classList.add('xactive');
        document.body.classList.add('xt-cart-recommended-active');
        let xcart_item_count = document.querySelector('.xcart_item_count').value;
        if (xcart_item_count == 2) {
          updateProgressBar(66.66);
        }
      });
    
      document.querySelector('.xheader').addEventListener('click', function() {
        document.querySelector('.xt-cart-recommended').classList.remove('xactive');
        document.body.classList.remove('xt-cart-recommended-active');
      });
    }
  }

  // Method to update the free shipping progress
  // updateFreeShippingProgress(cartTotal, hasSellingPlan) 
  // {
  //   const freeShippingThresholdElement = document.getElementById('freeshiipingthreshold'); // Free shipping threshold
  //   const freeShippingThreshold = freeShippingThresholdElement ? freeShippingThresholdElement.value : null;
  //   const progressBarContainer = document.querySelector('.xt-progress-bar'); // Progress bar container
  //   console.log(freeShippingThreshold); // Logs the value of the hidden input, or null if not found
  //   const progressBar = document.getElementById('file'); // Progress bar element
  //   const label = document.getElementById('remainingprice'); // Label for remaining amount text

  //   if (!progressBar || !label) {
  //     console.error('Progress bar or label element is missing.');
  //     return;
  //   }

  //    // If any item has a selling plan, show free shipping achieved
  //   if (hasSellingPlan) {
  //     progressBar.value = 100; // Set progress to 100%
  //     label.textContent = `Congratulations! You qualify for Free Shipping.`;
  //     progressBarContainer.classList.add("freeshippingachieved");
  //     return;
  //   }

  //   // Calculate the progress percentage
  //   const progress = Math.min((cartTotal / freeShippingThreshold) * 100, 100);

  //   // Update the progress bar value
  //   progressBar.value = progress;

  //   // Update the label text
  //   if (cartTotal >= freeShippingThreshold) {
  //     progressBarContainer.classList.add("freeshippingachieved");
  //   } else {
  //     const remaining = (freeShippingThreshold - cartTotal).toFixed(2);
  //     console.log(remaining);
  //     label.textContent = `$${remaining}`;
  //     progressBarContainer.classList.remove("freeshippingachieved");
  //   }
  // }

  

  // // Method to fetch cart total and update the progress bar
  // fetchCartTotalAndUpdateProgress() {
  //   fetch('/cart.js') // Shopify cart endpoint
  //     .then((response) => response.json())
  //     .then((cart) => {
  //       const cartTotal = cart.total_price / 100; // Shopify total_price is in cents
  //       const hasSellingPlan = cart.items.some((item) => item.selling_plan_allocation); // Check for selling plans
  //       this.updateFreeShippingProgress(cartTotal, hasSellingPlan);
  //     })
  //     .catch((error) => {
  //       console.error('Failed to fetch cart total:', error);
  //     });
  // }

  // Handle selling plan change event
  handleSellingPlanChange(event) {

    console.log(event);
    const lineItemIndex = event.target.dataset.index;
    console.log(lineItemIndex);
    const newSellingPlanId = event.target.value;
    const lineItem = this.querySelector(`#CartDrawer-Item-${lineItemIndex}, #CartItem-${lineItemIndex}`);
    console.log(lineItem);
    const quantityInput = lineItem.querySelector('input[data-quantity-variant-id]');
    const quantityValue = quantityInput.value; 
    
    const variantId = quantityInput.getAttribute('data-quantity-variant-id');
    const SellingPlan = this.getUpdatedSellingPlan(newSellingPlanId);
    this.updateSellingPlan(lineItemIndex, quantityValue, lineItem.querySelector('input[name="updates[]"]').name, variantId, SellingPlan);
  }

  getUpdatedSellingPlan(sellingPlanId) {
    return {
      sellingPlanId,
    };
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
     const index = event.target.dataset.index;
      let message = '';
  
      if (inputValue < event.target.dataset.min) {
        message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
      } else if (inputValue > parseInt(event.target.max)) {
        message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
      } else if (inputValue % parseInt(event.target.step) !== 0) {
        message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
      }
  
      if (message) {
        // this.setValidity(event, index, message);
      } else {
        event.target.setCustomValidity('');
        event.target.reportValidity();
        this.updateQuantity(
          index,
          inputValue,
          // document.activeElement.getAttribute('name'),
          event.target.dataset.quantityVariantId
        );
      }
  }

  onChange(event) {

    console.log(event);
    this.validateQuantity(event);
    // this.fetchCartTotalAndUpdateProgress();
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contentssecond',
      },
    ];
  }

   updateSellingPlan(line, quantity, name, variantId, SellingPlan) {
    this.enableLoading(line);

    // Ensure SellingPlan is defined and contains a sellingPlanId
    const sellingPlanID = SellingPlan && SellingPlan.sellingPlanId ? SellingPlan.sellingPlanId : null;
    console.log(sellingPlanID);
     console.log(this.getSectionsToRender().map((section) => section.section));
     console.log(window.location.pathname);
    // Prepare the body for the request, passing the updated selling plan
    const body = JSON.stringify({
      line,
      quantity,
      selling_plan: sellingPlanID,  // Pass the updated selling plan here
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    // Perform the fetch request to update the cart
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        // Handle errors from the cart update
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        // Toggle visibility for empty cart
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        // Update the relevant sections in the DOM
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        // Check if the quantity in the cart matches the updated value
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        // Publish the updated cart state
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId });
      })
      .catch(() => {
        // Handle any errors during the fetch request
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        // Disable loading state after the request
        this.disableLoading(line);
      });
  }
  
// -----------------------------------------------------------------------------
 
updateQuantity(line, quantity, name, variantId) {

    this.enableLoading(line);
    // Show global spinner at header

    const spinner = document.querySelector('.loading__spinner_gwp');
    const checkoutButtonID = document.querySelector('#CartDrawer-Checkout');
    if (checkoutButtonID) {
      checkoutButtonID.disabled = true;
      checkoutButtonID.classList.add('disabled'); // optional for styling
      checkoutButtonID.style.opacity = '0.6';
      checkoutButtonID.style.pointerEvents = 'none';
    }
    
    if (spinner) spinner.style.display = 'inline-block';
   
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {

        //this is for check free gift item
        fetch('/cart.js')
        .then(response => response.json())
        .then(async cart => {  // ✅ Made async
          const cartTotal = cart.total_price;
          const cart_item_count = cart.item_count;
          
          // Get all free gift items in cart
          const giftItemsInCart = cart.items.filter(function(item) {
            return (item.properties != null && item.properties['_free_gift_product'] == 'true');
          });
          
          // OLD LOGIC: Remove free gift if cart is empty
          if (giftItemsInCart.length > 0 && cart_item_count == 1 && cartTotal == 0) {
            let line = 1;
            let quantity = 0;
            this.enableLoading(line);
            const body = JSON.stringify({
                line,
                quantity,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname,
              });
          
              fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
                .then((response) => {
                  return response.text();
                })
                .then((state) => {
                const parsedState = JSON.parse(state);
                this.renderCartUpdate(parsedState, line, name, variantId);
            })
            .catch(() => {
              this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
              const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
              errors.textContent = window.cartStrings.error;
            })
            .finally(() => {
              this.disableLoading(line);
              if (spinner) spinner.style.display = 'none';
              if (checkoutButton) {
                checkoutButton.disabled = false;
                checkoutButton.classList.remove('disabled');
                checkoutButton.style.opacity = '1';
                checkoutButton.style.pointerEvents = 'auto';
              }
            });
          }
          // ✅ NEW LOGIC: Check if gifts need to be added/removed based on threshold
          else if (window.giftWithPurchaseConfig && window.giftWithPurchaseConfig.enabled) {
            
            // Check if cart qualifies for ANY gifts
            const qualifiesForGift = await this.checkCartQualificationForUpdate(cart.items);
            
            if (!qualifiesForGift && giftItemsInCart.length > 0) {
              // Cart no longer qualifies - remove ALL free gifts
              console.log('Cart no longer qualifies - removing all free gifts');
              await this.removeGiftsSequentially(giftItemsInCart, cart);
              
              // Refresh cart after removing gifts
              this.refreshCartAfterGiftRemoval(state, line, name, variantId);
            } else if (qualifiesForGift) {
              // Cart qualifies - check which gifts should be in cart based on threshold
              const eligibleGifts = this.determineEligibleGiftsForUpdate(cartTotal, cart.items);
              const currentGiftVariantIds = giftItemsInCart.map(item => item.variant_id);
              
              // Find gifts to remove (in cart but no longer eligible)
              const giftsToRemove = this.determineGiftsToRemove(giftItemsInCart, eligibleGifts);
              
              // Find gifts to add (eligible but not in cart)
              const giftsToAdd = eligibleGifts.filter(gift => 
                !currentGiftVariantIds.includes(gift.variantId)
              );
              
              // Process removals first, then additions
              if (giftsToRemove.length > 0) {
                console.log('Removing gifts that no longer meet threshold');
                await this.removeGiftsSequentially(giftsToRemove, cart);
              }
              
              if (giftsToAdd.length > 0) {
                console.log('Adding new gifts that now meet threshold');
                await this.addGiftsSequentiallyInUpdate(giftsToAdd);
              }
              
              // Refresh cart after all changes
              if (giftsToRemove.length > 0 || giftsToAdd.length > 0) {
                this.refreshCartAfterGiftRemoval(state, line, name, variantId);
              } else {
                // No changes needed, proceed normally
                const parsedState = JSON.parse(state);
                this.renderCartUpdate(parsedState, line, name, variantId);
              }
            } else {
              // Cart doesn't qualify and no gifts in cart - proceed normally
              const parsedState = JSON.parse(state);
              this.renderCartUpdate(parsedState, line, name, variantId);
            }
          }
          else {
            // Feature disabled - proceed normally
            const parsedState = JSON.parse(state);
            this.renderCartUpdate(parsedState, line, name, variantId);
          }
          
        })
        .catch(error => {
         console.error('Error fetching cart:', error);
         // Fallback to normal rendering on error
         const parsedState = JSON.parse(state);
         this.renderCartUpdate(parsedState, line, name, variantId);
        });
        
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  // ✅ Helper function to check cart qualification (for updateQuantity)
  checkCartQualificationForUpdate(cartItems) {
    const config = window.giftWithPurchaseConfig;
    
    let qualifyingProductIds = config.qualifyingProductIds || [];
    
    if (typeof config.qualifyingProductIdsString === 'string' && config.qualifyingProductIdsString !== '') {
      qualifyingProductIds = config.qualifyingProductIdsString.split(',').map(id => parseInt(id.trim()));
    }
    
    // If no restrictions set, all carts qualify
    if (qualifyingProductIds.length === 0) {
      return true;
    }
    
    // Check each cart item (excluding free gifts)
    for (let item of cartItems) {
      // Skip free gift items
      if (item.properties && item.properties['_free_gift_product'] == 'true') {
        continue;
      }
      
      const itemProductId = parseInt(item.product_id);
      
      if (qualifyingProductIds.includes(itemProductId)) {
        return true;
      }
    }
    
    return false;
  }

  // ✅ Helper function to determine eligible gifts (for updateQuantity)
  determineEligibleGiftsForUpdate(cartTotal, cartItems) {
    const config = window.giftWithPurchaseConfig;
    const eligibleGifts = [];
    
    // Check each tier from highest to lowest
    for (let tierConfig of config.tiers.slice().reverse()) {
      if (!tierConfig.enabled || !tierConfig.variantId) {
        continue;
      }
      
      // Check if threshold met
      if (cartTotal >= tierConfig.threshold) {
        eligibleGifts.push({
          tier: tierConfig.tier,
          variantId: parseInt(tierConfig.variantId),
          threshold: tierConfig.threshold
        });
      }
    }
    
    return eligibleGifts;
  }

  // ✅ Helper function to determine which gifts need to be removed
  determineGiftsToRemove(giftItemsInCart, eligibleGifts) {
    const eligibleVariantIds = eligibleGifts.map(g => g.variantId);
    
    // Find gifts that are in cart but no longer eligible
    const giftsToRemove = giftItemsInCart.filter(item => {
      return !eligibleVariantIds.includes(item.variant_id);
    });
    
    // Sort by line index in reverse order (remove highest line number first)
    giftsToRemove.sort((a, b) => {
      const lineA = parseInt(a.key.split(':')[0]);
      const lineB = parseInt(b.key.split(':')[0]);
      return lineB - lineA;
    });
    
    console.log('Gifts to remove:', giftsToRemove.map(g => `Line ${g.key.split(':')[0]} - Variant ${g.variant_id}`));
    
    return giftsToRemove;
  }

  // ✅ Helper function to remove gifts sequentially
  async removeGiftsSequentially(giftsToRemove, cart) {
    for (let gift of giftsToRemove) {
      // Find the line number of this gift in the cart
      const lineNumber = cart.items.findIndex(item => item.id === gift.id) + 1;
      
      if (lineNumber > 0) {
        console.log(`Removing gift from line ${lineNumber}...`);
        
        const body = JSON.stringify({
          line: lineNumber,
          quantity: 0,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });
        
        try {
          const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } });
          const result = await response.text();
          console.log(`✅ Removed gift from line ${lineNumber}`);
          
          // Update cart object for next iteration
          const updatedCart = JSON.parse(result);
          cart.items = updatedCart.items || [];
        } catch (error) {
          console.error(`Error removing gift from line ${lineNumber}:`, error);
        }
      }
    }
  }

  // ✅ NEW: Helper function to add gifts sequentially (for updateQuantity)
  async addGiftsSequentiallyInUpdate(giftsToAdd) {
    const cartElement = document.querySelector('cart-drawer');
    
    for (let gift of giftsToAdd) {
      console.log(`Adding gift tier ${gift.tier} (variant: ${gift.variantId})...`);
      
      const formData = new FormData();
      formData.append('id', gift.variantId);
      formData.append('quantity', 1);
      formData.append('properties[_free_gift_product]', 'true');
      
      if (cartElement) {
        formData.append(
          'sections',
          cartElement.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }
      
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
      
      try {
        const response = await fetch(`${routes.cart_add_url}`, config);
        const result = await response.json();
        console.log(`✅ Added gift tier ${gift.tier}`);
      } catch (error) {
        console.error(`Error adding gift tier ${gift.tier}:`, error);
      }
    }
  }

  // ✅ Helper function to refresh cart after gift removal/addition
  refreshCartAfterGiftRemoval(state, line, name, variantId) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Fetch fresh cart sections
        const cartElement = document.querySelector('cart-drawer');
        
        if (cartElement) {
          const formData = new FormData();
          formData.append(
            'sections',
            cartElement.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;
          
          fetch(`${routes.cart_update_url}`, config)
            .then(response => response.json())
            .then((freshResponse) => {
              console.log('✅ Cart refreshed after gift changes');
              cartElement.renderContents(freshResponse);
            })
            .catch(error => {
              console.error('Error refreshing cart:', error);
              // Fallback
              const parsedState = JSON.parse(state);
              this.renderCartUpdate(parsedState, line, name, variantId);
            });
        } else {
          // No cart element, use standard rendering
          const parsedState = JSON.parse(state);
          this.renderCartUpdate(parsedState, line, name, variantId);
        }
      })
      .catch(error => {
        console.error('Error refreshing cart:', error);
        const parsedState = JSON.parse(state);
        this.renderCartUpdate(parsedState, line, name, variantId);
      });
  }

  // ✅ Helper function to handle cart rendering (extracted from duplicate code)
  renderCartUpdate(parsedState, line, name, variantId) {
    const quantityElement =
      document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
    const items = document.querySelectorAll('.cart-item');

    if (parsedState.errors) {
      quantityElement.value = quantityElement.getAttribute('value');
      this.updateLiveRegions(line, parsedState.errors);
      return;
    }

    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });
    
    const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
    let message = '';
    if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
      if (typeof updatedValue === 'undefined') {
        message = window.cartStrings.error;
      } else {
        message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
      }
    }
    this.updateLiveRegions(line, message);

    const lineItem =
      document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper
        ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
        : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
    } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
    }

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
  }

  // -----------------------------------------------------------------------------

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
